<template>
    <div>
        <div class="page-title">
            <h4>{{$t('txt.lucrari')}}</h4>
        </div>
        <div class="offer-add-client single-wrapper-upper">
            <div class="offer-add-option" v-if="!client_form_status">
                <div class="template-select-type">
                    <v-select name="client_id" v-model="selected_client" :options="clients" :get-option-label="clientName" :placeholder="$t('placeholder.alegeClient')"></v-select>
                    <p class="custom-error-info"> {{errors.first('client_id')}} </p>
                </div>
                <span class="connector"> {{$t('txt.connector')}} </span>
                <div class="add-client-button">
                    <button type="button" v-on:click="client_form_status = !client_form_status">
                        <i class="fas fa-user-plus"></i>
                        <span> {{$t('txt.adaugaClient')}} </span>
                    </button>
                </div>
            </div>
            <div class="offer-client-form works-client-template" v-bind:class="{ocf_active : client_form_status}">
                <h4> {{$t('txt.adaugaClient')}} </h4>
                <sequential-entrance fromTop delay="50">
                    <div class="form-group"
                         v-for="input_field in add_client_fields"
                         :key="input_field.id">
                        <input type="text" class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :name="input_field.inputName"
                               v-model="input_field.inputValue"
                               :data-vv-as="input_field.labelName"
                               :id="input_field.inputName">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                    <div class="offer-return-button">
                        <button type="button" v-on:click="client_form_status = !client_form_status">
                            <i class="fas fa-long-arrow-alt-left"></i>
                            {{$t('txt.inapoi')}}
                        </button>
                        <button type="button" @click.prevent="addClient()">
                            <i class="fas fa-check"></i>
                            {{$t('salveaza')}}
                        </button>
                    </div>
                </sequential-entrance>
            </div>
        </div>
        <form class="works-container" id="works">
            <div class="works-template">
                <h4> {{$t('txt.data')}}: </h4>
                <div class="form-group custom-error-group">
                    <date-picker v-validate="'required'" :not-before="new Date()" name="date" v-model="date" type="datetime" lang="en" format="YYYY:MM:DD HH:mm:ss"></date-picker>
                    <p class="custom-error-info"> {{errors.first('date')}} </p>
                </div>
            </div>
            <div class="works-template">
                <h4> {{$t('txt.numarFactura')}}: </h4>
                <div class="form-group custom-error-group">
                   <input type="text" class="form-control" v-validate="'required'" v-model="billing_number">
                    <label> {{$t('txt.numarFactura')}}: </label>
                    <span class="focus-input"></span>
                    <span class="symbol-input">
                        <i class="fas fa-file-invoice-dollar"></i>
                    </span>
                </div>
            </div>
            <div class="works-template">
                <h4> {{$t('txt.denumireProdus')}}: </h4>
                <div class="form-group custom-error-group">
                    <v-select v-validate="'required'" v-model="selected_product" :options="products" label="name" :placeholder="$t('placeholder.alegeProdusul')"></v-select>
                    <p class="custom-error-info"> {{errors.first('product_id')}} </p>
                </div>
            </div>
            <div class="works-template">
                <h4> {{$t('txt.serialNumber')}}: </h4>
                <div class="form-group custom-error-group">
                    <input type="text" class="form-control" v-validate="'required'" v-model="product_serial">
                    <label> {{$t('txt.serialNumber')}}: </label>
                    <span class="focus-input"></span>
                    <span class="symbol-input">
                        <i class="fas fa-hashtag"></i>
                    </span>
                </div>
            </div>
            <div class="works-template">
                <h4> {{$t('placeholder.alegeColaboratorul')}}: </h4>
                <div class="form-group custom-error-group">
                    <v-select name="client_id" v-model="selected_collaborator" :options="collaborators" :get-option-label="clientName" :placeholder="$t('placeholder.alegeColaboratorul')"></v-select>
                    <p class="custom-error-info"> {{errors.first('client_id')}} </p>
                </div>
            </div>
            <div class="works-save-buttons">
                <button @click.prevent='AddWork()' :disabled="this.$store.state.loading">
                    <i class="fas fa-check"></i>
                    {{$t('placeholder.salveaza')}}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import ProductsService from '../../api-services/products.service.js'
import ClientsService from '../../api-services/clients.service.js'
import ServiceService from '../../api-services/service.service.js'
import PartnersService from '../../api-services/partners.service.js'
import localforage from 'localforage'
export default {
  name: 'works',
  data () {
    return {
      selected_product: [],
      selected_client: [],
      selected_collaborator: [],
      client_form_status: false,
      products: [],
      clients: [],
      collaborators: [],
      date: '',
      billing_number: null,
      product_serial: null,
      collaboratorsArray: [],
      productsArray: [],
      clientsArray: []
    }
  },
  components: {
    DatePicker
  },
  computed: {
    add_client_fields () {
      return [
        {
          inputName: 'first_name',
          labelName: this.$t('placeholder.nume'),
          inputValue: '',
          icon: 'fas fa-signature',
          validationRules: ''
        },
        {
          inputName: 'last_name',
          labelName: this.$t('placeholder.prenume'),
          inputValue: null,
          icon: 'fas fa-signature',
          validationRules: ''
        },
        {
          inputName: 'company_name',
          labelName: this.$t('placeholder.numeCompanie'),
          inputValue: null,
          icon: 'fas fa-building',
          validationRules: ''
        },
        {
          inputName: 'phone',
          labelName: this.$t('placeholder.telefon'),
          inputValue: '',
          icon: 'fas fa-phone',
          validationRules: 'numeric'
        },
        {
          inputName: 'address',
          labelName: this.$t('placeholder.adresa'),
          inputValue: '',
          icon: 'fas fa-map-marker-alt',
          validationRules: ''
        },
        {
          inputName: 'email',
          labelName: this.$t('placeholder.email'),
          inputValue: '',
          icon: 'fas fa-envelope',
          validationRules: 'email'
        }
      ]
    }
  },
  methods: {
    AddWork () {
      if (!this.selected_client || Array.isArray(this.selected_client)) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selectClient'),
          'animation-type': 'css'
        })
        return false
      }

      if (!this.date) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selectData'),
          'animation-type': 'css'
        })
        return false
      }
      if (!this.billing_number) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.produsFactura'),
          'animation-type': 'css'
        })
        return false
      }
      if (!this.selected_product || Array.isArray(this.selected_product)) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selectProdus'),
          'animation-type': 'css'
        })
        return false
      }

      if (!this.product_serial) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.produsSerie'),
          'animation-type': 'css'
        })
        return false
      }

      if (!this.selected_collaborator || Array.isArray(this.selected_collaborator)) {
        this.$notify({
          group: 'error',
          type: 'error',
          title: this.$t('errors.errorTitle'),
          text: this.$t('errors.selectCollaborator'),
          'animation-type': 'css'
        })
        return false
      }

      let data = {
        client_id: this.selected_client.id,
        product_id: this.selected_product.id,
        billing_number: this.billing_number,
        product_serial: this.product_serial,
        date: this.date,
        partner_id: this.selected_collaborator.id
      }
      let date = new Date(this.date)
      data.date = ('0' + date.getDate()).slice(-2) + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' +
        date.getFullYear() + ' ' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) +
         ':' + ('0' + date.getSeconds()).slice(-2)
      ServiceService.create(data)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.lucrareAdaugata'),
              'animation-type': 'css'
            })
            this.$router.push('/service/vtp')
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            let errors = Object.entries(error.response.data.error)
            let msgError = ''
            for (const [key, msg] of errors) {
              console.log(key)
              msgError += '<br>' + msg
            }
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: msgError,
              'animation-type': 'css'
            })
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    },
    addClient () {
      let clientObj = {}
      this.add_client_fields.forEach(function (element) {
        let key = [element.inputName]
        clientObj[key] = element.inputValue
      })
      ClientsService.create(clientObj)
        .then((response) => {
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.clientAdaugat'),
            'animation-type': 'css'
          })
          this.clients.push(response.data.data)
          this.selected_client = this.clients.find(client => client.id === response.data.data.id)
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) return
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    },
    getCollaborators () {
      localforage.getItem('partners').then((response) => {
        this.collaborators = response.sort((a, b) => {
          let textA = ''
          let textB = ''
          if (a.company_name === null) {
            textA = (a.first_name || '').toUpperCase().trim() + (a.last_name || '').toUpperCase().trim()
          } else {
            textA = a.company_name.toUpperCase().trim()
          }
          if (b.company_name === null) {
            textB = (b.first_name || '').toUpperCase().trim() + (b.last_name || '').toUpperCase().trim()
          } else {
            textB = b.company_name.toUpperCase().trim()
          }
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      })
      PartnersService.getAll({ per_page: 500 })
        .then((response) => {
          this.collaboratorsArray.push(response.data.data)
          for (let i = 1; i <= response.data.meta.last_page; i++) {
            PartnersService.getAll({ per_page: 500, page: i })
              .then((response) => {
                if (response.data.data.length) {
                  this.collaboratorsArray.push(response.data.data)
                  this.collaborators = this.collaboratorsArray.reduce(function (prev, curr) {
                    return prev.concat(curr)
                  }).sort((a, b) => {
                    let textA = ''
                    let textB = ''
                    if (a.company_name === null) {
                      textA = (a.first_name || '').toUpperCase().trim() + (a.last_name || '').toUpperCase().trim()
                    } else {
                      textA = a.company_name.toUpperCase().trim()
                    }
                    if (b.company_name === null) {
                      textB = (b.first_name || '').toUpperCase().trim() + (b.last_name || '').toUpperCase().trim()
                    } else {
                      textB = b.company_name.toUpperCase().trim()
                    }
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
                  })
                }
              })
              .catch((error) => {
                console.log(error)
              })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getProducts () {
      localforage.getItem('products').then((response) => {
        this.products = response.sort((a, b) => {
          let textA = a.name.toUpperCase().trim()
          let textB = b.name.toUpperCase().trim()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      })
      ProductsService.getAll({ per_page: 500 })
        .then((response) => {
          this.productsArray.push(response.data.data)
          for (let i = 1; i <= response.data.meta.last_page; i++) {
            ProductsService.getAll({ per_page: 500, page: i })
              .then((response) => {
                if (response.data.data.length) {
                  this.productsArray.push(response.data.data)
                  this.products = this.productsArray.reduce(function (prev, curr) {
                    return prev.concat(curr)
                  }).sort((a, b) => {
                    let textA = a.name.toUpperCase().trim()
                    let textB = b.name.toUpperCase().trim()
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
                  })
                }
              })
              .catch((error) => {
                console.log(error)
              })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getClients () {
      localforage.getItem('clients').then((response) => {
        this.clients = response.sort((a, b) => {
          let textA = ''
          let textB = ''
          if (a.company_name === null) {
            textA = (a.first_name || '').toUpperCase().trim() + (a.last_name || '').toUpperCase().trim()
          } else {
            textA = a.company_name.toUpperCase().trim()
          }
          if (b.company_name === null) {
            textB = (b.first_name || '').toUpperCase().trim() + (b.last_name || '').toUpperCase().trim()
          } else {
            textB = b.company_name.toUpperCase().trim()
          }
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      })
      this.$store.dispatch('hideLoading')
      ClientsService.getAll({ per_page: 500 })
        .then((response) => {
          this.clientsArray.push(response.data.data)
          for (let i = 1; i <= response.data.meta.last_page; i++) {
            ClientsService.getAll({ per_page: 500, page: i })
              .then((response) => {
                if (response.data.data.length) {
                  this.clientsArray.push(response.data.data)
                  this.clients = this.clientsArray.reduce(function (prev, curr) {
                    return prev.concat(curr)
                  }).sort((a, b) => {
                    let textA = ''
                    let textB = ''
                    if (a.company_name === null) {
                      textA = (a.first_name || '').toUpperCase().trim() + (a.last_name || '').toUpperCase().trim()
                    } else {
                      textA = a.company_name.toUpperCase().trim()
                    }
                    if (b.company_name === null) {
                      textB = (b.first_name || '').toUpperCase().trim() + (b.last_name || '').toUpperCase().trim()
                    } else {
                      textB = b.company_name.toUpperCase().trim()
                    }
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
                  })
                }
              })
              .catch((error) => {
                console.log(error)
              })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
    let query = this.$route.query
    if (query && query.date) {
      this.date = new Date(query.date)
    }
    // this.getClients()
    // this.getProducts()
    // this.getCollaborators()
  }
}
</script>
